import LineChartCustom from "../../components/Incidents/charts/LineChart";

const xLabels = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const processData = (incidents) => {
  if (incidents) {
    const incidentTypes = new Set();
    const cleanedIncidents = {};

    // Clear data: replace "" with "Not set"
    Object.keys(incidents).forEach((day) => {
      const dayData = incidents[day];
      if (Array.isArray(dayData)) {
        cleanedIncidents[day] = {};
        return;
      }
      cleanedIncidents[day] = { ...dayData };

      if (dayData[""]) {
        cleanedIncidents[day]["Not set"] = (dayData["Not set"] || 0) + dayData[""];
        delete cleanedIncidents[day][""];
      }
    });

    // Collect all possible types of incidents
    Object.values(cleanedIncidents).forEach((dayData) => {
      Object.keys(dayData).forEach((type) => incidentTypes.add(type));
    });

    const incidentData = {};
    incidentTypes.forEach((type) => {
      incidentData[type] = Array(7).fill(0);
    });

    // Fill in the data by days of the week
    xLabels.forEach((day, index) => {
      const dayData = cleanedIncidents[day] || {};
      Object.keys(dayData).forEach((type) => {
        if (!incidentData[type]) {
          incidentData[type] = Array(7).fill(0);
        }
        incidentData[type][index] = dayData[type];
      });
    });

    return Object.keys(incidentData).map((type) => ({
      data: incidentData[type],
      label: type,
      showMark: true,
      curve: "linear",
    }));
  } else return [];
};

const IncidentTypesOverTimeChart = ({ data }) => {
  const series = processData(data);

  return <LineChartCustom xLabels={xLabels} series={series} />;
};

export default IncidentTypesOverTimeChart;
